import { carCountContrast, getMaintenance, getStatisticalData, getCountryCarCount, getDayViolationAndMalfunction } from "../../api/config/modules/HomeZeki";

const state = {
  carCountContrast: {},
  getMaintenance: {},
  getStatisticalData: {},
  getCountryCarCount: {},
  getDayViolationAndMalfunction: {}
};

const mutations = {
  SET_CARCOUNTCONTRAST: (state, carCountContrast) => {
    state.carCountContrast = carCountContrast;
  },
  SET_GETMAINTENANCE: (state, getMaintenance) => {
    state.getMaintenance = getMaintenance;
  },
  SET_GETSTATISTICALDATA: (state, getStatisticalData) => {
    state.getStatisticalData = getStatisticalData;
  },
  SET_GETCOUNTRYCARCOUNT: (state, getCountryCarCount) => {
    state.getCountryCarCount = getCountryCarCount;
  },
  SET_GETDAYVIOLATIONANDMALFUNCTION: (state, getDayViolationAndMalfunction) => {
    state.getDayViolationAndMalfunction = getDayViolationAndMalfunction;
  }
};

const actions = {
  GET_CARCOUNTCONTRAST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      carCountContrast(data)
        .then((res) => {
          commit("SET_CARCOUNTCONTRAST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETMAINTENANCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getMaintenance(data)
        .then((res) => {
          commit("SET_GETMAINTENANCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETSTATISTICALDATA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getStatisticalData(data)
        .then((res) => {
          commit("SET_GETSTATISTICALDATA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCOUNTRYCARCOUNT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCountryCarCount(data)
        .then((res) => {
          commit("SET_GETCOUNTRYCARCOUNT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETDAYVIOLATIONANDMALFUNCTION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getDayViolationAndMalfunction(data)
        .then((res) => {
          commit("SET_GETDAYVIOLATIONANDMALFUNCTION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
